var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, Fragment, cloneElement } from 'react';
import _merge from 'lodash.merge';
import ECharts from '../ECharts';
import Tooltip from '../components/Tooltip';
import Funnel from '../series/Funnel';
import Legend from '../components/Legend';
import { EChartsContext } from '../constants';
import { is } from '../utils';
const funnelDefaultWidth = 40;
function FunnelChart(_a, ref) {
    var { asc = false, tooltip = true, name, data = [], children, option } = _a, props = __rest(_a, ["asc", "tooltip", "name", "data", "children", "option"]);
    function renderDefaultFunnel() {
        const funnelPosition = {
            width: `${funnelDefaultWidth}%`,
            left: `${(100 - funnelDefaultWidth) / 2}%`
        };
        return (React.createElement(Fragment, null,
            React.createElement(Funnel, Object.assign({ name: name, data: data, asc: asc }, funnelPosition)),
            React.createElement(Legend, { data: data.map(([name]) => name) })));
    }
    function renderFunnels(funnels) {
        // 2 个以内给排排版
        if (funnels.length === 1) {
            const funnelPosition = {
                width: `${funnelDefaultWidth}%`,
                left: `${(100 - funnelDefaultWidth) / 2}%`
            };
            return funnels.map((funnel, index) => (React.createElement(Fragment, { key: index },
                cloneElement(funnel, funnelPosition),
                React.createElement(Legend, { data: funnel.props.data.map(([name]) => name) }))));
        }
        const occupiedColorsCount = (index) => funnels.slice(0, index).reduce((sum, funnel) => sum + funnel.props.data.length, 0);
        if (funnels.length === 2) {
            return funnels.map((funnel, index) => {
                const funnelPosition = {
                    width: `${funnelDefaultWidth}%`,
                    left: `${5 + 50 * index}%`
                };
                return (React.createElement(Fragment, { key: index },
                    cloneElement(funnel, Object.assign(Object.assign({}, funnelPosition), { color: funnel.props.color &&
                            new Array(occupiedColorsCount(index)).concat(funnel.props.color) })),
                    React.createElement(Legend, Object.assign({ data: funnel.props.data.map(([name]) => name) }, funnelPosition))));
            });
        }
        return funnels.map((funnel, index) => (React.createElement(Fragment, { key: index },
            cloneElement(funnel, {
                color: funnel.props.color && new Array(occupiedColorsCount(index)).concat(funnel.props.color)
            }),
            React.createElement(Legend, { data: funnel.props.data.map(([name]) => name) }))));
    }
    const components = Children.toArray(children);
    const funnels = components.filter(comp => is(comp, 'funnel'));
    let titleOption = {};
    if (!funnels.length) {
        titleOption = {
            title: {
                text: name,
                left: '50%',
                top: '10%',
                textAlign: 'center',
                textVerticalAlign: 'bottom',
                textStyle: { color: '#272c36', fontSize: 14, fontWeight: 'normal' }
            }
        };
    }
    if (funnels.length <= 2) {
        titleOption = {
            title: funnels.map((funnel, index) => ({
                text: funnel.props.name,
                left: `${funnels.length === 1 ? 50 : 5 + funnelDefaultWidth / 2 + index * 50}%`,
                top: '10%',
                textAlign: 'center',
                textVerticalAlign: 'bottom',
                textStyle: { color: '#272c36', fontSize: 14, fontWeight: 'normal' }
            }))
        };
    }
    return (React.createElement(EChartsContext.Provider, { value: { chartType: 'funnel', dataName: name } },
        React.createElement(ECharts, Object.assign({ ref: ref, option: _merge(titleOption, option) }, props),
            !funnels.length && renderDefaultFunnel(),
            funnels.length > 0 && renderFunnels(funnels),
            tooltip && React.createElement(Tooltip, null),
            components.filter(comp => !is(comp, 'funnel')))));
}
export default React.forwardRef(FunnelChart);
//# sourceMappingURL=FunnelChart.js.map